import React from "react";
import Main from "layouts/Main";
import { deleteDataset, getDatasetList } from "services/api";
import { Box, Card, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AddCircleOutline, Delete, Edit, Lock, MoreHoriz, PostAdd } from "@mui/icons-material";
import { Dataset } from "types/dataset";
import { useConfirmDialog } from "components/ConfirmDialog";
import Loading from "components/Loading";
import Container from "components/Container";
import { showSnackbar } from "services/snackbarHelper";

const DatasetList = () => {
	const { t } = useTranslation(["common"]);
	const { openDialog } = useConfirmDialog();

	const [datasets, setDatasets] = React.useState<Dataset[]>([]);
	const [isLoading, setIsLoading] = React.useState(true);

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const onDelete = (id: string, index: number) => {
		deleteDataset(id).then((resp) => {
			if (resp.info) {
				showSnackbar(t("deleteSuccess", { ns: "validation" }), "success");
				updateList();
			}
		});
	};

	const handleDelete = (id: string, index: number) => {
		handleClose();
		openDialog(t("deleteDataset"), t("deleteDatasetMessage"), () => onDelete(id, index));
	};

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const updateList = () => {
		return getDatasetList().then((resp) => {
			if (!resp || resp?.error) return;
			setDatasets(resp.datasets);
		});
	};
	React.useEffect(() => {
		setIsLoading(true);
		updateList().finally(() => setIsLoading(false));
	}, []);
	React.useEffect(() => {
		console.log(datasets);
	}, [datasets]);
	return (
		<Main title={t("allDatasets")}>
			{isLoading ? (
				<Loading />
			) : (
				<Container>
					<Box
						width={1}
						display="flex"
						justifyContent={"flex-end"}>
						<IconButton
							size="small"
							href="/app/dataset/edit">
							<AddCircleOutline />
						</IconButton>
					</Box>
					<Box
						overflow="hidden"
						width={1}>
						{datasets.length === 0 ? (
							<Typography textAlign={"center"}>{t("noDataset")}</Typography>
						) : (
							datasets.map((dataset, i) => {
								return (
									<Card
										key={dataset.id}
										sx={{ width: 1 }}>
										<Box
											p={2}
											display={"flex"}
											flexDirection={"row"}
											gap={1}
											justifyContent={"space-between"}
											alignItems={"center"}>
											<Box
												display={"flex"}
												flexDirection={"column"}
												flex={1}
												overflow="hidden">
												<Box
													display={"flex"}
													alignItems={"center"}
													gap={"4px"}>
													<Typography fontWeight={500}>{dataset.name}</Typography>
													<Lock sx={{ height: 16, width: 16 }} />
												</Box>

												<Typography
													variant="body2"
													color="textSecondary"
													noWrap>
													{dataset.description}
												</Typography>
											</Box>
											<Box
												display={"flex"}
												flexShrink={0}>
												<IconButton
													id={dataset.id}
													onClick={handleClick}>
													<MoreHoriz />
												</IconButton>
											</Box>

											<Menu
												anchorEl={anchorEl}
												open={open}
												onClose={handleClose}
												MenuListProps={{
													role: "listbox",
												}}>
												{dataset.editable && (
													<>
														<MenuItem
															component="a"
															href={"/app/dataset/edit/" + anchorEl?.id}>
															<ListItemIcon>
																<Edit fontSize="small" />
															</ListItemIcon>
															<ListItemText sx={{ "& .MuiTypography-root": { fontWeight: 500 } }}>{t("editDataset")}</ListItemText>
														</MenuItem>
														<MenuItem
															component="a"
															href={"/app/document/add/" + anchorEl?.id}>
															<ListItemIcon>
																<PostAdd fontSize="small" />
															</ListItemIcon>
															<ListItemText sx={{ "& .MuiTypography-root": { fontWeight: 500 } }}>{t("addDocument")}</ListItemText>
														</MenuItem>
													</>
												)}
												<MenuItem
													onClick={() => {
														handleDelete(anchorEl?.id, i);
													}}
													sx={{ color: "error.main" }}>
													<ListItemIcon>
														<Delete
															fontSize="small"
															color="error"
														/>
													</ListItemIcon>
													<ListItemText sx={{ "& .MuiTypography-root": { fontWeight: 500 } }}>{t("deleteDataset")}</ListItemText>
												</MenuItem>
											</Menu>
										</Box>
									</Card>
								);
							})
						)}
					</Box>
				</Container>
			)}
		</Main>
	);
};

export default DatasetList;
